<div class="table-cnt">


<table *ngIf="dataSource" class="reb-table" mat-table [dataSource]="dataSource" >
    <ng-container [matColumnDef]="col.key" *ngFor="let col of config.cols" >

        <th mat-header-cell *matHeaderCellDef>{{col.name}} </th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="!col.cellTemplate">

            {{resolve(col.key, element)}}
        </ng-container>
        <ng-container *ngIf="col.cellTemplate">
            <ng-container *ngTemplateOutlet="cellTemplate, context: { $implicit: {data:element,value:element[col.key], col} }">
                <ng-content select="[actiontemplate]"></ng-content>
            </ng-container>
            </ng-container>
        </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              {{noResultsMessage}}
            </td>
          </tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

        <!-- Grid Skeleton -->
        <div *ngIf="!dataSource" class="grid-content">
          <mat-list class="custom-mat-list list-grid-std list-customer-invoices">
            <!-- skeleton header -->
            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
              <div class="cell-wrapper col-first">
                <div class="cell col-invoice flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
              </div>
              <div class="cell-wrapper col-info">
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
              </div>
            </mat-list-item>
            <!-- skeleton body -->
            <mat-list-item class="custom-mat-list-item grid-row">
              <div class="cell-wrapper col-first">
                <div class="cell col-invoice flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
              </div>
              <div class="cell-wrapper col-info">
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
                <div class="cell flex-order">
                  <label matline>
                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                  </label>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
</div>

